export default __webpack_public_path__ + "static/media/Mercado pago.0d2ad5a9.svg";